import { useEffect } from "react";
import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { Title2 } from "@components/new/Typo";
import ButtonWithTimer from '@components/new/ButtonWithTimer/ButtonWithTimer';
import DigitInput from "@components/DigitInput";
import { linkSendCode } from "@api/apiClient";
import { getErrorMessage } from "@utils/errorMessage";
import styles from './ConfirmEmail.module.scss';

export type ConfirmState = {
  disabled: boolean,
  loading: boolean,
}

const ConfirmEmail = ({ pin, setPin, email, apiKey, clientId, setTicket, onSubmit, setConfirmState, error }: {
  email: string;
  apiKey?: string;
  clientId?: string;
  pin: string;
  setPin: (v: string) => void;
  setTicket: (v: string) => void;
  onSubmit: () => void;
  setConfirmState: (v: ConfirmState) => void;
  error?: any;
}) => {
  const { t } = useTranslation();

  const sendLinkMutation = useMutation({
    mutationFn: linkSendCode,
  });

  const resendPin = () => {
    sendLinkMutation.mutate({ email, apiKey, clientId }, {
      onSuccess: ({ ticketId }) => {
        setTicket(ticketId);
      },
    });
  }

  useEffect(() => {
    if (pin.trim().length === 4) onSubmit();
  }, [pin]);

  useEffect(() => {
    setConfirmState({
      disabled: pin.trim().length < 4,
      loading: sendLinkMutation.isLoading,
    })
  }, [pin, sendLinkMutation.isLoading]);

  return (
    <div className={styles.formConfirm}>
      <Title2
        className={styles.title}
        dangerouslySetInnerHTML={{
          __html: t("storesPage.addShopModal.confirmEmailMsg", { email }),
        }}
      />
      <DigitInput
        value={pin}
        onChange={setPin}
        disabled={sendLinkMutation.isLoading}
        hasError={Boolean(error) || sendLinkMutation.isError}
        errorMessage={getErrorMessage({ t, error: sendLinkMutation.isError ? sendLinkMutation.error : error })}
        length={4}
        name="pin"
        alignFooter="center"
      />
      <ButtonWithTimer
        onClick={resendPin}
        pending={sendLinkMutation.isLoading}
        title={t("storesPage.addShopModal.resendCode")}
        startTimerFromOutside
        asLink
        disabledOnTimer
      />
    </div>
  )
};

export default ConfirmEmail;
